import ko from 'knockout';
import _ from 'lodash';
import templateMarkup from 'raw-loader!./share-dashboard-adv-modal.html';
import '../../app/bindings/ko-bindinghandler-tokenfield';
import PreferenceService from "../../services/preference.service";
import Selectr from 'mobius1-selectr/src/selectr';
import DashboardService from '../../modules/assurance/services/dashboard.service';

function ShareDashboardAdv(params) {
  let self = this;

  if (!_.has(params, 'signals.onShow') || !_.has(params, 'signals.onSave')) {
    throw new Error('ShareDashboardAdv:: Missing required signals: show, save');
  }
  self.signals = params.signals;
  self.signals.onShow.add(_.bind(self.show, self));
  self.signals.onSave.add(_.bind(self.save, self));

  self.updateError = ko.observable();
  self.hasUpdateError = ko.pureComputed(function () {
    return !_.isEmpty(self.updateError());
  });

  self.fromOrgSelctr = new Selectr('#fromOrgSelector', {
    defaultSelected: false,
    placeholder: 'Select a Org...'
  } );
  self.fromUserSelctr = new Selectr('#fromUserSelector2', {
    defaultSelected: false,
    placeholder: 'Select a User...'
  } );

  let appViewData = [
    {
      text: "CPM Analytics&reg;",
      children: [
        {
          value: "historical2/historical2dashboard",
          text: "My Dashboards"
        },
        {
          value: "historical2/historical2adoption",
          text: "Adoption"
        },
        {
          value: "historical2/historical2issues",
          text: "Issues"
        },
        {
          value: "historical2/historical2capacity",
          text: "Capacity"
        },
        {
          value: "historical2/historical2roomboard",
          text: "Workspaces"
        }
      ]
    },
    {
      text: "CPM Monitoring&reg;",
      children: [
        {
          value: "assurance/dashboard",
          text: "My Dashboards"
        }
      ]
    },
    {
      text: "Workspace Insights",
      children: [
        {
          value: "rooms/historical2roomboard",
          text: "My Dashboards"
        }
      ]
    }
  ];


  self.fromAppSelctr = new Selectr('#fromAppSelector2', {
    allowDeselect: true,
    clearable: true,
    defaultSelected: false,
    placeholder: 'Select an App and View...',
    data: appViewData
  } );

  self.tabsListSelctr = new Selectr('#dashboardSelector2', {
    defaultSelected: false,
    placeholder: 'Select Dashboards...'
  } );

  self.toOrgSelctr = new Selectr('#toOrgSelector', {
    defaultSelected: false,
    placeholder: 'Select a Org...'
  } );

  self.toUsersSelctr = new Selectr('#toUsersSelector2', {
    defaultSelected: false,
    placeholder: 'Select a User...'
  } );

  self.toAppSelctr =new Selectr('#toAppSelector', {
    allowDeselect: true,
    clearable: true,
    defaultSelected: false,
    placeholder: 'Select an App and View...',
    data: appViewData
  } );

  self.fromOrgSelctr.on('selectr.select', function(option) {
    self.fromUserSelctr.clear();
    self.fromUserSelctr.removeAll();

    self.tabsListSelctr.clear();
    self.tabsListSelctr.removeAll();

    self.fromAppSelctr.clear();
    self.fromAppSelctr.reset(); // technically I don't need to do this, but it make loading easier

    self.toOrgSelctr.setValue(self.fromOrgSelctr.getValue());
    DashboardService.fetchUsersForOrgTemp(self.fromOrgSelctr.getValue()).then(users => {
      _.forEach(users, user => {
        if (!user.deleted) {
          self.fromUserSelctr.add({value: user.id, text: user.id + "." + user.name})
        }
      })
    });
  });

  self.fromUserSelctr.on('selectr.select', function(option) {
    self.fromAppSelctr.clear();
    self.fromAppSelctr.reset(); // technically I don't need to do this, but it make loading easier
  });

  self.toOrgSelctr.on('selectr.select', function(option) {
    self.toUsersSelctr.clear();
    self.toUsersSelctr.removeAll();
    DashboardService.fetchUsersForOrgTemp(self.toOrgSelctr.getValue()).then(users => {
      _.forEach(users, user => {
        if (!user.deleted) {
          self.toUsersSelctr.add({value: user.id, text: user.id + "." + user.name})
        }
      })
    });
  });

  self.fromAppSelctr.on('selectr.select', function(option) {
    let appView = self.fromAppSelctr.getValue();
    let appViewArray = appView.split('/');
    self.toAppSelctr.setValue(appView);
    self.tabsListSelctr.clear();
    self.tabsListSelctr.removeAll();
    PreferenceService.getTabsForOrg(appViewArray[0], appViewArray[1], self.fromOrgSelctr.getValue(), self.fromUserSelctr.getValue()).then( tabList => {
      _.forEach(tabList, tab => {
        self.tabsListSelctr.add({value: tab.id, text: tab.name});
      });
    });
  });

  self.saveCallback = null;

}

ShareDashboardAdv.prototype.show = function (model) {
  var self = this;

  if (!_.has(model, 'appId')) {
    throw new Error('ShareDashboardAdv needs a model with an appId.');
  }
  if (!_.has(model, 'viewId')) {
    throw new Error('ShareDashboardAdv needs a model with an viewId.');
  }
// not sure if I need any of these to pre-populate the advanced dialog entries
  // self.appId = model.appId;
  // self.viewId = model.viewId;
  // self.currentBoard = model.currentBoard;
  // self.currentUserId = model.currentUserId;

  self.saveCallback = model.saveCallback;
  self.updateError(null);

  // not super efficient resetting and reloading all data, but works for now
  self.fromOrgSelctr.clear();
  self.fromOrgSelctr.removeAll();
  self.fromUserSelctr.clear();
  self.fromUserSelctr.removeAll();

  self.fromAppSelctr.clear();
  self.fromAppSelctr.reset();

  self.tabsListSelctr.clear();
  self.tabsListSelctr.removeAll();
  self.toOrgSelctr.clear();
  self.toOrgSelctr.removeAll();
  self.toUsersSelctr.clear();
  self.toUsersSelctr.removeAll();

  self.toAppSelctr.clear();
  self.toAppSelctr.reset();

  DashboardService.fetchAllOrgsTemp().then(orgs => {
    _.forEach(orgs, org => {
      if (!org.deleted) {
        self.fromOrgSelctr.add({value: org.id, text: org.id + "." + org.name})
        self.toOrgSelctr.add({value: org.id, text: org.id + "." + org.name})
      }
    })
  });



// todo limit the toApp based in the fromApp X->X CPMA -> rooms?


  // DashboardService.fetchUsersForCurrentOrgTemp().then(users => {
  //   _.forEach(users, user => {
  //     if (!user.deleted) {
  //       self.toUsersSelctr.add({value: user.id, text: user.name})
  //     }
  //   })
  // });
  //
};

ShareDashboardAdv.prototype.save = function () {
  var self = this;

  let fromAppViewArray = self.fromAppSelctr.getValue().split('/');
  let toAppViewArray = self.toAppSelctr.getValue().split('/');

  var from = { user: Number(self.fromUserSelctr.getValue()),     appId: fromAppViewArray[0], viewId: fromAppViewArray[1] , boards: self.tabsListSelctr.getValue() };
  var to   = { users: self.toUsersSelctr.getValue().map(Number), appId: toAppViewArray[0],   viewId: toAppViewArray[1]};
  console.log("Copy "+ JSON.stringify(from) + " to "+ JSON.stringify(to));

  try {
    PreferenceService.addTabs(from, to);
    self.updateError('');
  } catch (e) {
    console.error(e);
    self.updateError('There was an error sharing the dashboards.');
  }

  if (!self.hasUpdateError()) {
    self.signals.closeModal.dispatch();
    if (self.saveCallback) self.saveCallback();
  }
};

ShareDashboardAdv.prototype.dispose = function () {
  var self = this;
  self.signals.onShow.dispose();
  self.signals.onSave.dispose();
};

export default {viewModel: ShareDashboardAdv, template: templateMarkup};
